import React, { Component } from "react";
import ReactDOM from "react-dom";
import DemandDetail from "./DemandDetail";

export default class RenderDemandDetail extends Component {
  state = {
    isOpen: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isOpen !== this.state.isOpen) {
      document.body.classList.toggle("modal-open", this.state.isOpen);
      document.body.style.overflow = this.state.isOpen ? "hidden" : "";
    }
  }

  componentWillUnmount() {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
  }

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen } = this.state;

    return (
      <>
        <button
          type="button"
          className="t-memberInfo-btn t-memberInfo-btn--secondary t-myDemands-detailBtn"
          onClick={this.openModal}
        >
          <span>Detay</span>
        </button>

        {isOpen &&
          ReactDOM.createPortal(
            <DemandDetail demand={this.props.data} onClose={this.closeModal} />,
            document.body
          )}
      </>
    );
  }
}
